import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { confirmService } from 'src/app/core/providers/confirm/confirmService';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-form',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './modal-form.component.html',
  styleUrl: './modal-form.component.scss',
})
export class ModalFormComponent {
  @Input() modalTitle: string = ''; // Titre de la carte
  @Input() buttonTitle: string = 'Enregistrer'; // Titre de la carte
  @Input() isEditMode: boolean = false; // Mode édition
  @Input() isSaving: boolean = false;
  @Input() showClose: boolean = true;
  @Input() showDelete: boolean = false;
  @Input() hasRole: boolean = true;
  @Output() toggleEditMode = new EventEmitter<void>();
  @Output() submitForm = new EventEmitter<void>();
  @Output() dismissModal = new EventEmitter<void>();
  @Output() deleteItem = new EventEmitter<void>();

  constructor(
    private confirmService: confirmService,
    public translate: TranslateService
  ) {}

  // Fonction pour basculer entre le mode édition et affichage
  onToggleEditMode(): void {
    this.toggleEditMode.emit();
  }

  // Fonction pour soumettre le formulaire
  onSubmitForm(): void {
    this.submitForm.emit();
  }

  onDismissModal(): void {
    this.dismissModal.emit();
  }

  onDeleteItem(): void {
    this.confirmService
      .openConfirmationModal(
        this.translate.instant('modalForm.confirmationTitle'),
        this.translate.instant('modalForm.confirmationMessage'),
        this.translate.instant('modalForm.confirmButton'),
        this.translate.instant('modalForm.cancelButton')
      )
      .then((confirmed) => {
        if (confirmed) {
          this.deleteItem.emit();
        }
      })
      .catch(() => {});
  }
}
